import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { PRODUCT_CATEGORIES, categoryHref, categorySlug } from "@/data/categories";

/**
 * CategoryGrid — Jumia-style icon tiles for the full product taxonomy.
 * Each tile routes to a category-filtered Browse URL so buyers skip the filter.
 */
const CategoryGrid = () => (
  <section className="container-narrow py-12 sm:py-14" data-testid="category-grid">
    <div className="flex items-end justify-between gap-4 mb-6">
      <div>
        <div className="label-overline text-[#C05A3C] mb-2">Shop by category</div>
        <h2 className="font-display text-2xl sm:text-3xl tracking-tight leading-tight">
          Find what you&apos;re looking for in seconds.
        </h2>
      </div>
      <Link
        to="/browse?type=product"
        className="hidden sm:inline-flex items-center gap-1 text-sm font-medium text-[#1A1A1A] hover:text-[#C05A3C] transition-colors"
        data-testid="category-grid-browse-all"
      >
        Browse everything <ChevronRight className="w-4 h-4" />
      </Link>
    </div>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
      {PRODUCT_CATEGORIES.map(({ label, icon: Icon, accent, ring }) => (
        <Link
          key={label}
          to={categoryHref(label)}
          data-testid={`category-tile-${categorySlug(label)}`}
          className={`group relative overflow-hidden rounded-xl bg-white border border-black/10 hover:border-transparent hover:ring-2 ${ring} transition-all duration-300 p-4 sm:p-5 hover:-translate-y-0.5`}
        >
          <div className={`absolute inset-0 bg-gradient-to-br ${accent} opacity-0 group-hover:opacity-100 transition-opacity duration-300`} aria-hidden />
          <div className="relative flex items-center gap-3">
            <div className="shrink-0 w-11 h-11 rounded-lg bg-[#F3EFE9] grid place-items-center group-hover:bg-white transition-colors">
              <Icon className="w-5 h-5 text-[#1A1A1A]" />
            </div>
            <div className="min-w-0">
              <div className="font-semibold text-sm sm:text-base leading-tight text-[#1A1A1A] group-hover:text-[#C05A3C] transition-colors">
                {label}
              </div>
              <div className="text-[11px] uppercase tracking-wider text-muted-foreground mt-0.5">
                Products
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  </section>
);

export default CategoryGrid;
